import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { TimeRangeProvider } from './contexts/TimeRangeContext';
import { AuthProvider, ProtectedRoute } from './contexts/AuthContext';
import { Toaster } from './components/ui/toaster';
import Sidebar from './components/Sidebar';
import SimpleSettingsModal from './components/settings/SimpleSettingsModal';
import Login from './pages/Login';
import Revenue from './pages/Revenue';
import RevenueDetails from './pages/RevenueDetails';
import Overview from './pages/Overview';
import Users from './pages/Users';
import Feedback from './pages/Feedback';
import Settings from './pages/Settings';
import UserInsights from './pages/users/UserInsights';
import AllUsers from './pages/users/AllUsers';
import ActiveUsers from './pages/users/ActiveUsers';
import UserRevenue from './pages/users/Revenue';
import UserConversions from './pages/users/Conversions';
import { useTheme } from './hooks/useTheme';
import { useAuth } from './contexts/AuthContext';

const AppContent = () => {
  const { theme, isDark } = useTheme();
  const { isAuthenticated, isLoading } = useAuth();
  const [settingsOpen, setSettingsOpen] = useState(false);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="flex h-screen bg-background items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  console.log('settingsOpen state:', settingsOpen);

  return (
    <div className="flex h-screen bg-background">
      <Sidebar onSettingsClick={() => setSettingsOpen(true)} />
      <main className="flex-1 flex flex-col overflow-hidden">
        <Routes>
          <Route path="/" element={<ProtectedRoute><Overview onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="/revenue-details" element={<ProtectedRoute><RevenueDetails onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="/revenue/details" element={<ProtectedRoute><RevenueDetails onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="/revenue" element={<ProtectedRoute><Revenue onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><Users onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="/users/insights" element={<ProtectedRoute><UserInsights onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="/users/all" element={<ProtectedRoute><AllUsers onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="/users/active" element={<ProtectedRoute><ActiveUsers onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="/users/revenue" element={<ProtectedRoute><UserRevenue onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="/users/conversions" element={<ProtectedRoute><UserConversions onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="/feedback" element={<ProtectedRoute><Feedback onSettingsClick={() => setSettingsOpen(true)} /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
          {/* <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} /> */}
        </Routes>
      </main>
      <SimpleSettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </div>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <TimeRangeProvider>
        <Router>
          <AuthProvider>
            <AppContent />
            <Toaster />
          </AuthProvider>
        </Router>
      </TimeRangeProvider>
    </ThemeProvider>
  );
};

export default App; 